import Api from "./api";
import OidcManager from "./oidcManager";
import {HistoryState} from "./estimate-rows";


export interface IApplicationState {
    estimateId: number;
    selectedRows: number[];
    costBookId: number | undefined;
    costbooks: { id: number, name: string, selectedRows: number[], page: number, importDate: Date }[]
}

export interface QboCustomer {
    Id: string;
    Name: string;
}

export interface EstimateQboInfo {
    qboCustomerId: string;
    qboCustomers: QboCustomer[];
    taxOption: number;
    isSuccess: boolean;
    errorCode: number;
    errorMessage: string;
}

export interface missingInfo {
    companyInfo: boolean;
    customerInfo: boolean;
    jobInfo: boolean;
}

export default class EstimatesApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }
    
    searchEstimates(loadOptions: DevExpress.data.LoadOptions) :JQueryPromise<{totalCount: number, data: {id: number, name: string, createdAt: string, modifiedAt: string, openedAt: string }[]}> {
        
        let command = this.loadOptionsToActionParams(loadOptions, false);
        
        return super.get("/api/estimates/search", command);
    }

    getEstimate(id: number) :JQueryPromise<{
        id: number, 
        name: string, 
        postalCode: string,
        equipmentPriceOverride: boolean,
        laborPriceOverride: boolean,
        materialPriceOverride: boolean,
        createdAt: string, 
        modifiedAt: string, 
        openedAt: string, 
        history: HistoryState, 
        state: IApplicationState,
        estimateNumber: number | undefined,
        estimateDate: Date | undefined,
        jobName: string,
        owner: string,
        description: string,
        planDate: Date | undefined,
        estimatedBy: string,
        checkedBy: string,
        completeDescription: string,
    }> {

        return super.get("/api/estimates/" + id, {});
    }

    saveEstimateQboInfo(command: { estimateId: number, qboCustomerId: string, taxOption: number }) : JQueryPromise<any> {
        return super.post("/api/qbo/save-estimate-info", command)
    }
    
    getEstimateQboInfo(id: number) :JQueryPromise<EstimateQboInfo> {

        return super.get("/api/qbo/estimate-info/" + id, {});
    }

    createEstimate(command: { name: string }): JQueryPromise<{id: number, name: string, postalCode: string, estimateNumber: number, state: IApplicationState}> {

        return super.put("/api/estimates", command)
    }

    renameEstimate(command: { id: number, name: string }): JQueryPromise<{}> {

        return super.post("/api/estimates/rename", command)
    }    
    
    deleteEstimate(command: { id: number  }): JQueryPromise<{}> {

        return super.delete("/api/estimates", command)
    }

    saveAsEstimate(command: { id: number, name: string }): JQueryPromise<number> {
        return super.post("/api/estimates/saveas", command);
    }    
    
    saveState(command: IApplicationState): JQueryPromise<{}> {
        return super.put("/api/estimates/state", command);
    }

    saveSettings(command: {
        id: number,
        estimateNumber: number | undefined,
        estimateDate: Date | undefined,
        jobName: string,
        owner: string,
        description: string,
        planDate: Date | undefined,
        estimatedBy: string,
        checkedBy: string,
        completeDescription: string,
    }): JQueryPromise<{}> {
        console.log("saveSettings", command);
        return super.put("/api/estimates/settings", command);
    }

    importLegacyTab(name: string, file: File): JQueryPromise<{ id: number, name: string, postalCode: string, state: IApplicationState }> {

        let formData = new FormData();
        formData.append("name", name);
        formData.append("file", file, file.name);
        return super.postForm("/api/estimates/import-legacy-tab", formData);
    }

    getMissingInfo(command: { id: number}): JQueryPromise<missingInfo> {
        return super.post("/api/estimates/check-missing-info", command);
    }

    setDoNotShowMissingInfoFlag(command: { id: number}): JQueryPromise<number> {
        return super.post("/api/estimates/set-missing-info-flag", command);
    }

    export(command: { estimateId: number }): JQueryPromise<any> {
        return super.getBlob("/api/estimates/export", command);
    }

    import(command: { estimateFile: File }): JQueryPromise<any> {
        let formData = new FormData();
        formData.append("file", command.estimateFile, command.estimateFile.name);
        return super.postForm("/api/estimates/import", formData);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/estimates.ts